module.exports = "//cdn-staging.livechat-static.com/webapp/img/notification-icon@2x.png?a46cef1e1f81b5081a4e0aabc09879ce";